import { render, staticRenderFns } from "./RecPointModal.vue?vue&type=template&id=1e1be0c1&scoped=true"
import script from "./RecPointModal.vue?vue&type=script&lang=js"
export * from "./RecPointModal.vue?vue&type=script&lang=js"
import style0 from "./RecPointModal.vue?vue&type=style&index=0&id=1e1be0c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1be0c1",
  null
  
)

export default component.exports